import React from 'react';
import Input from '../../Input';

const DistrictInput = ({
  width,
  disabled,
  value,
  setValue,
  userData,
  validate,
  valid,
  isErrorApiCep,
}) => {
  return (
    <Input
      id='Bairro'
      labelName={'Bairro'}
      size={width}
      disabled={disabled}
      value={value}
      marginTop={0}
      onBlur={validate}
      error={valid === false && isErrorApiCep}
      errorMessage={'Digite um bairro válido'}
      handleInputChange={(e) =>
        setValue({
          ...userData,
          Enderecos: [
            {
              ...userData.Enderecos[0],
              Bairro: e.currentTarget.value,
            },
          ],
        })
      }
    />
  );
};

export default DistrictInput;
